import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import StudentMCQPage from './pages/StudentMCQPage';
import UnauthorizedPage from './pages/UnauthorizedPage';

import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login"         element={<LoginPage />} />
          <Route path="/mcq/:shareCode" element={<StudentMCQPage />} />

          <Route path="/admin/*" element={
            <PrivateRoute requiredRole="admin">
              <AdminDashboard />
            </PrivateRoute>
          } />

          <Route path="/teacher/*" element={
            <PrivateRoute requiredRole="teacher">
              <TeacherDashboard />
            </PrivateRoute>
          } />

          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="/"             element={<Navigate to="/login" />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
          toastStyle={{ fontSize: '0.875rem', fontFamily: 'Inter, sans-serif' }}
        />
      </AuthProvider>
    </Router>
  );
}

export default App;
